<template>
    <div>
        <div class="row">
            <div class="col-12 col-lg-12 p-0">
                <NotiPos/>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-12">
                <b-form-group id="input-group-1" label-for="input-search-couier">
                    <b-input-group>
                        <b-form-input
                            id="input-search-couier"
                            type="text"
                            v-model="searchCourier"
                            placeholder="ค้นหาขนส่ง"
                            class="mt-2"
                        >
                        <b-input-group-append>
                            <div class="d-flex align-items-center justify-content-center">
                                <i class="fas fa-search text-muted"></i>
                            </div>
                        </b-input-group-append>
                        </b-form-input>  
                    </b-input-group>
                </b-form-group>
            </div>
        </div>
        <b-card-text class="p-0 scroll-bar-pop card-tab">
            <div class="row pr-3 py-2">
                <div class="col-6 col-lg-6 col-xl-8">
                    <h4 class="cursor-pointer d-flex align-items-center text-color-draft" v-if="!checkThemeQuick()" @click="emitModal('draftStorage')">
                        <span>
                            <img :src="iconDraft.url" alt="">
                        </span>
                        <span class="ml-1">
                            {{ draftLength ? `ฉบับร่าง (${countDraft()})` : "ฉบับร่าง (0)" }}
                        </span>
                    </h4>
                </div>
                <div class="col-6 col-lg-6 col-xl-4 text-right">
                    <b-button 
                        id="checkPrice" 
                        :class="showCart !== 'non-slide' ? 'mr-4' : ''" 
                        variant="primary" 
                        size="sm" 
                        :disabled="(idOrder) ? true : false" 
                        @click="changeStepPosPage(getStepPage.STEP_PAGE_CHECKPRICE)" 
                    >
                        <i class="fas fa-database"></i>
                        เปรียบเทียบราคา
                    </b-button>
                </div>
            </div>
            <!-- COD CARD -->
            <div class="row pr-3">
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="cod">
                    <CardPos
                        :courier="{
                        title:'COD เก็บเงินปลายทาง', 
                        name:'COD', 
                        icon:'cod_by_shippop.jpg',
                    }"
                    :starShow="false"
                    :class="{disabled:idOrder,lockcourier:(lockCardCourier.courier || lockCardCourier.cod),}"
                    @click.native="$emit('openModal','COD','')"
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.dropoffShippop">
                    <CardPos 
                    :courier="{
                    title:'DROP OFF (ลทบ / EMS)' , 
                    name: 'SHIPPOP DROP OFF' , 
                    icon:'shippop-logo',
                    }" 
                    :starShow="false"
                    :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffShippop}"
                    @click.native="$emit('openModal', DROPOFF_SP , false)"
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.dropoffVRich">
                    <CardPos
                    :courier="{
                        title:'DROP OFF (V RICH)', 
                        name:'V RICH DROP OFF', 
                        icon:'vrich-logo.png',
                    }"
                    :starShow="false"
                    :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffVrich}"
                    @click.native="$emit('courierModalTime', courierDropoffVRich , '' ) , dropoffVRich.show = true"
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.dropoffPanPan">
                    <CardPos
                        :courier="{
                            title:'DROP OFF (PANPANWORLD)', 
                            name:'PANPAN WORLD DROP OFF', 
                            icon:'panpanworld-logo.png',
                        }"
                        :starShow="false"
                        :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffPanPan}"
                        @click.native="
                            $emit('courierModalTime', dropoffPanPan.courier , '' ) , 
                            dropoffPanPan.show = true
                        "
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.dropoffEasyShip">
                    <CardPos
                    :courier="{
                        title:'DROP OFF (EASYSHIP)', 
                        name:'EASYSHIP DROP OFF', 
                        icon:'easyship-logo.png',
                    }"
                    :starShow="false"
                    :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffEasyship}"
                    @click.native="$emit('courierModalTime', courierDropoffEasyShip , '' ) , dropoffEasyShip.show = true , dropoffEasyShip.notCloseModal = true"
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.kerryDropoff">
                    <CardPos
                    :courier="{
                        title:'Kerry Drop off',
                        name:'Kerry Drop off',
                        icon:'kerry-dropoff-logo.png',
                    }"
                    :starShow="false"
                    :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffKerry}"
                    @click.native="$emit('openModal', KERRY_DROPOFF , false)"
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2"  v-if="permission.lazadaDropoff">
                    <CardPos
                    :courier="{
                        title:'Lazada Drop off',
                        name:'Lazada Drop off',
                        icon: 'LZDS.png'
                    }"
                    :starShow="false"
                    :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffLazada}"
                    @click.native="$emit('openModal', LAZADA_DROPOFF , false)"
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.orangeDropoff">
                    <CardPos
                    :courier="{
                        title:'Orange Drop off',
                        name:'Orange Drop off',
                        icon:'ORNG.png',
                    }"
                    :starShow="false"
                    :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffKerry}"
                    @click.native="$emit('openModal', ORANGE_DROPOFF , false)"
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.dropoffQuick">
                    <CardPos
                    :courier="{
                        title:'DROP OFF (QUICK EXPRESS)', 
                        name:'QUICK EXPRESS DROP OFF', 
                        icon:'quick-logo.png',
                    }"
                    :starShow="false"
                    :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffQuick}"
                    @click.native="$emit('courierModalTime',courierDropoffQuick , '' ) , dropoffQuick.show = true"
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.lineBooking">
                    <CardPos
                        :courier="{
                            title:'LINE Booking', 
                            name:'LINE Booking', 
                            icon:'LINE_logo.png',
                        }"
                        :starShow="false"
                        :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffLine}"
                        @click.native="$emit('openModal', 'LINE_BOOKING' , false)" 
                    />
                </div>
                <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.flashDropoff">
                    <CardPos 
                        :courier="{
                            title: 'Flash Drop off',
                            name: 'Flash Drop off',
                            icon: 'FLE.jpg'
                        }"
                        :starShow="false"
                        :class="{disabled:idOrder , lockcourier:lockCardCourier.dropoffFlash}"
                        @click.native="$emit('openModal', FLASH_DROPOFF , false)" 
                    />
                </div>
                <template v-for="courier in courierFilter" >
                    <div v-if="showCourier(courier)"
                    class="col-12 col-lg-6 col-xl-3 mb-3 pr-2"
                    :key="courier.id" >
                    {{courier.showCourier}}
                    <CardPos
                        v-if="courier.shippop == 1 && courier.prebarcode == 0"
                        :courier="courier"
                        prebarcode=""
                        @returnEmit="emitCourierModalTime"
                        :class="{disabled:idOrder,lockcourier:lockCardCourier.courier}"
                        :starShow="true"
                    />
                    <CardPos
                        v-else-if="courier.shippop == 0"
                        :courier="courier"
                        prebarcode=""
                        @returnEmit="emitCourierModalTime"
                        :class="{disabled:idOrder , lockcourier:lockCardCourier.gen}"
                        :starShow="true"
                    />
                    <CardPos
                        v-else
                        :courier="courier"
                        prebarcode="prebarcode"
                        @returnEmit="emitCourierModalTime"   
                        :class="{disabled:idOrder,lockcourier:lockCardCourier.prebarcode}"
                        :starShow="true"
                    />
                    </div>
                </template>
            </div>
        </b-card-text>
    </div>
</template>

<script>
import CardPos from "@/components/CardPos";
import NotiPos from "@/components/custom/pos/NotiPos"
import { 
    getStepPage
} from "@/plugins/posHelper.js";

export default {
    props:{
        showCart: String,
        cart: Array,
        draftStorage: [Object, Array],
        idOrder: [String, Number],
        posPage: Object,
        tabCourier: Object,
        couriers: Array,
        searchCourier: String,
        permission: Object,
        dropoffVRich: Object,
        dropoffPanPan: Object,
        dropoffEasyShip: Object,
        dropoffQuick: Object,
        cod: [String, Number],
        lockCardCourier: Object,
        DROPOFF_SP: String,
        LAZADA_DROPOFF: String,
        KERRY_DROPOFF: String,
        ORANGE_DROPOFF: String,
        FLASH_DROPOFF: String,
        showCourier: Function,
        courierDropoffVRich: [Object, Array],
        courierDropoffEasyShip: [Object, Array],
        courierDropoffQuick: [Object, Array],
        shopId: [Number, String]
    },
    data() {
        return {
            getStepPage: getStepPage,
            favCourierAll: Array,
            iconDraft: {
                url: require("../../../assets/icon/Drafts.svg")
            }
        }
    },
    components:{
        CardPos,
        NotiPos
    },
    methods:{
        checkThemeQuick(){
            return this.$THEME.name == 'quickexpress';
        },
        emitModal(key) {
          return this.$emit('openModalDraft', key)  
        },
        countDraft() {
          return  this.draftStorage?Object.keys(this.draftStorage).length:0
        },
        draftLength() {
            return this.draftStorage?Object.keys(this.draftStorage).length > 0:false;
        },
       async getfavCourier() {
            const header = {
              headers: {
                  Token: localStorage.getItem("access_token")
              }
            }
            await this.$http.get(this.$API_URL + "/favCourier",header).then((res) => {
                this.favCourierAll = res.data.data
            })
        },
        changeStepPosPage( step ){
            if(getStepPage.STEP_PAGE_CHECKPRICE === step) {
                this.$emit('checkPriceFrom', 'DOMESTIC')
            }
            this.posPage.step = step
        },
        async emitCourierModalTime(e) {
            if(e.clickON && e.event.target.id === 'star') {
                e.event.stopPropagation()
                const header = {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
                if(e.deleteON === true) {
                    await this.getfavCourier()
                    const idReq = this.favCourierAll.item.filter(val => val.shop_id === this.shopId && val.courier_id === parseInt(e.courier.id))
                    if(idReq.length) {
                        this.$http.delete(this.$API_URL + `/favCourier/${idReq[0].id}`, header).then((res) => {
                            if(res.status === false) {
                                // eslint-disable-next-line
                                console.error("error", res.error)
                            }
                        }).finally(()=> {
                            return this.$emit('reverseCourier')
                        }) 
                    }else {
                        // eslint-disable-next-line
                        console.error("Could not found ID delete")
                    }
                }else {
                    const responeData = {
                        "courier_id" : e.courier.id
                    }
                    this.$http.post(this.$API_URL + "/favCourier", responeData, header)
                    return this.$emit('reverseCourier')
                    // window.location.reload()
                }
               
            } else {
                this.$emit('courierModalTime',e.courier,e.prebarcode)
            }
        }
    },
    computed:{
        courierFilter() {
            return this.couriers.filter(item => {
                const effective = new Date(item.effective_date) < new Date();
                const expired = new Date(item.expired_date).getTime() > new Date().getTime();
                return item.title
                .toLowerCase()
                .includes(this.searchCourier.toLowerCase()) && (!item.effective_date || effective) && (!item.expired_date || expired);
            });
        }
    }

}
</script>

<style>

</style>